<template>
	<div id="references" class="animated fadeIn"
		:key="$route.params.subRefCode3 || $route.params.subRefId2 || $route.params.subRefId || $route.params.referenceName">
		<b-row>
			<b-col cols="12">
				<not-allowed-alert v-if="notAllowedError" :deleteErrorMessage="deleteRefErrorMessage">
				</not-allowed-alert>

				<transition name="slide">
					<b-card>
						<div slot="header" class="d-flex justify-content-between custom-card-header">
							<h5 class="card-header-title"><strong>{{ parentRefName }}</strong> -
								{{ $t('sub-reference.title') }}</h5>

							<div class="card-header-actions">
								<b-link @click="showRefModal({})" size="sm" variant="primary"
									v-if="$can('create/edit', 'reference')">
									<i v-b-tooltip.hover :title="$t('reference.create.title')" class="fa fa-plus"
										style="font-size: 1.1em; color: #53575B"></i>
								</b-link>
							</div>
						</div>
						<!-- TABLE -->
						<b-table class="generalTableClass" responsive="sm" :items="getItemsForTable"
							:fields="computedFields" :current-page="currentPage" :per-page="perPage" hover="hover"
							striped="striped" bordered="bordered" show-empty>
							<!-- EMPTY SLOT FOR TABLE -->
							<template slot="empty" slot-scope="scope">
								<h4>{{ $t('empty') }}</h4>
							</template>
							<!-- EMPTY SLOT FOR TABLE -->

							<template slot="id" slot-scope="data">
								<strong>{{ data.item.id }}</strong>
							</template>

							<template slot="name" slot-scope="data">
								{{ data.value ? data.value : '&emsp;&emsp;&emsp;' }}
							</template>

							<template slot="code" slot-scope="data">
								<strong>{{ data.item.code }}</strong>
							</template>

							<template slot="packageCode" slot-scope="data" v-if="packageCodeVisible">
								{{ data.item.packageCode }}
							</template>

							<template slot="unitCode" slot-scope="data" v-if="packageCodeVisible">
								{{ data.item.unitCode }}
							</template>

							<template slot="value" slot-scope="data" class="col-md-8">
								{{ data.value ? data.value : '&emsp;&emsp;&emsp;' }}
							</template>

							<template slot="sort" slot-scope="data">
								{{ data.value ? data.value : '&emsp;&emsp;&emsp;' }}
							</template>

							<template slot="childRefs" slot-scope="data" class="col-md-8">
								<b-link v-if="!$route.params.subRefCode3" :key="data.item.id"
									@click="childRefsLink(data.item.code)">
									{{ $t('sub-reference.title') }}
								</b-link>
								<!--								<router-link :to="{ name: 'SubReferences2', params: {subRefId: data.item.id}}" append :key="data.item.id">{{$t('sub-reference.title')}}</router-link>-->
							</template>

							<template slot="actions" slot-scope="data">
								<b-link :key="data.item.id + 'delete'" @click="onOpen(data.item.id)"
									:id="'popOverDelete' + data.item.id" v-if="$can('delete', 'reference')">
									<i class="fa fa-trash"></i>
								</b-link>
								<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
								<b-popover :key="data.item.id + 'popover'" :target="'popOverDelete' + data.item.id"
									placement="auto" container="myContainer" :ref="'popover' + data.item.id"
									class="refDeleteConfirm">
									<template slot="title">
										<b-button @click="onClose(data.item.id)" class="close" aria-label="Close"
											style="margin-left: 5px">
											<span class="d-inline-block" aria-hidden="true">&times;</span>
										</b-button>
										{{ $t('actions.deletetitle') }}
									</template>

									<div>
										<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
										<b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
										<div class="row mt-1">
											<div class="col-6">
												<b-button variant="outline-danger" size="sm" block
													@click="onClose(data.item.id)">{{ $t('actions.no') }}
												</b-button>
											</div>
											<div class="col-6">
												<b-button variant="outline-success" size="sm" block
													@click="onOk(data.item.id)">{{ $t('actions.yes') }}
												</b-button>
											</div>
										</div>
									</div>
								</b-popover>
								<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

								<b-link @click="showRefModal(data)" v-b-tooltip.hover
									:title="$t('sub-reference.update-button')" v-if="$can('create/edit', 'reference')">
									<i class="fa fa-edit"></i>
								</b-link>
							</template>

						</b-table>
						<!-- TABLE -->

						<!-- PAGINATION -->
						<nav>
							<b-pagination :total-rows="getItemsForTable.length" :per-page="perPage"
								v-model="currentPage" :prev-text="$t('pagination.prev')"
								:next-text="$t('pagination.next')" hide-goto-end-buttons />
						</nav>
						<!-- PAGINATION -->

						<!-- MODAL FOR ADDING OR EDITING REFERENCE -->
						<b-modal body-class="refModal subReferenceModal" ref="updateRefModal" @shown="focusMyElement"
							hide-footer ok-title="Save"
							:title="modalForAdding ? $t('reference.create.title') : $t('reference.update-title')">
							<b-alert v-if="addRefError" :show="dismissCountDown" dismissible
								style="margin-bottom: 10px;" variant="warning" size="sm"
								@dismissed="dismissCountDown = 0" @dismiss-count-down="countDownChanged">
								<p v-for="(message, index) in addRefErrorMessages" :key="'message' + index">
									{{ $t(message) }}
								</p>
							</b-alert>
							<div>
								<p v-if="refInputNotFilled" style="color: red;">{{ $t('please-title') }}</p>

								<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"
									:label="$t('reference.create.name')" label-for="refName" class="required">
									<b-form-input :required="true"
										data-errormessage-value-missing="Это поле обязательно для заполнения!"
										id="childRefName" size="sm" v-model="item.name" autofocus=""
										ref="childRefNameRef" :placeholder="$t('reference.create.name')" />
								</b-form-group>

								<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"
									:label="$t('reference.create.code')" label-for="refCode" class="required">
									<b-form-input :required="true"
										data-errormessage-value-missing="Это поле обязательно для заполнения!"
										id="childRefCode" size="sm" v-model="item.code"
										:placeholder="$t('reference.create.code')" />
								</b-form-group>

								<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"
									:label="$t('reference.create.value')" label-for="refValue">
									<b-form-input id="childRefValue" size="sm" v-model="item.value"
										:placeholder="$t('reference.create.value')" />
								</b-form-group>

								<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"
									:label="$t('reference.create.sort')" label-for="refSort">
									<b-form-input id="childRefSort" size="sm" type="number" v-model="item.sort"
										:placeholder="$t('reference.create.sort')" />
								</b-form-group>

								<b-form-group label-cols="4" label-cols-lg="3" label-size="sm" :label="$t('mxikCode')"
									label-for="refSort">
									<b-form-input id="childRefSort" size="sm" v-model="item.mxikCode"
										:placeholder="$t('mxikCode')" />
								</b-form-group>

								<b-form-group v-if="packageCodeVisible" label-cols="4" label-cols-lg="3" label-size="sm"
									:label="$t('packageCode')" label-for="refSort">
									<b-form-input id="childRefSort" size="sm" type="number" v-model="item.packageCode"
										:placeholder="$t('packageCode')" />
								</b-form-group>

								<b-form-group v-if="packageCodeVisible" label-cols="4" label-cols-lg="3" label-size="sm"
									:label="$t('unitCode')" label-for="refSort" class="required">
									<b-form-input :required="true" id="childRefSort" size="sm" v-model="item.unitCode"
										:placeholder="$t('unitCode')" />
								</b-form-group>

								<b-form-checkbox id="checkbox-dept" v-model="item.markingRequired" name="checkbox-debt"
									class="d-flex align-items-center">
									Маркировочный код обязателен
								</b-form-checkbox>

								<div class="row mt-3 createRoleModalButtons justify-content-end">
									<div class="col-4">
										<b-button variant="outline-danger" size="sm" block @click="closeUpdateRefModal">
											{{ $t('actions.cancel') }}
										</b-button>
									</div>
									<div class="col-4">
										<b-button variant="outline-success" size="sm" block @click="saveRef">
											{{ $t('actions.save') }}
										</b-button>
									</div>
								</div>
							</div>
						</b-modal>
						<!-- MODAL FOR ADDING OR EDITING REFERENCE -->

					</b-card>
				</transition>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import CreateRefModalContent from './blocks/CreateRefModalContent'
import NotAllowedAlert from '../components/NotAllowedAlert'

const itemInitial = {
	id: null,
	parentId: null,
	parentName: '',
	code: '',
	name: '',
	value: '',
	sort: null,
	packageCode: undefined,
	unitCode: undefined,
	mxikCode: ''
};
export default {
	name: "Reference",
	components: {
		CreateRefModalContent,
		NotAllowedAlert
	},
	data() {
		return {
			parentRefName: 'Reference',
			dismissCountDown: 4,
			modalShowUpdate: false,
			focusedData: { id: null, key: null },
			refInputNotFilled: false,
			caption: "Reference's sub references",
			packageCodeVisible: ['/references/unit', '/references/warehouse_category/magazin'].includes(window.location.pathname),
			popoverShow: false,
			refField: [
				{
					key: 'id',
					label: this.$t('sub-reference.Id'),
					sortable: true
				},
				{
					key: 'name',
					label: this.$t('sub-reference.name')
				},
				{
					key: 'code',
					label: this.$t('sub-reference.code')
				},
				{
					key: 'value',
					label: this.$t('sub-reference.value')
				},
				{
					key: 'sort',
					label: this.$t('sub-reference.sort'),
					'class': 'ref_sort',
					sortable: true
				},
				{
					key: 'mxikCode',
					label: this.$t('mxikCode'),
					sortable: true
				},
				{
					key: 'packageCode',
					label: this.$t('packageCode'),
				},
				{
					key: 'unitCode',
					label: this.$t('unitCode'),
				},
				{
					key: 'childRefs',
					label: this.$t('reference.child')
				},
				{
					key: 'actions',
					label: this.$t('actions.title'),
					'class': 'table_actions'

				},

			],
			tempData: Object.assign({}, itemInitial),
			item: Object.assign({}, itemInitial),
			currentPage: 1,
			perPage: 20,
			totalRows: 0,
			modalForAdding: false

		}

	},
	computed: {
		...mapGetters('references', [
			'getRefChildren', 'getSubRefChildren', 'getReferences'
		]),
		...mapState('references', [
			'notAllowedError', 'deleteRefErrorMessage', 'addRefErrorMessages',
			'addRefError', 'subRefChildren2', 'subRefChildren3', 'refCurrencies'
		]),
		getItemsForTable() {
			if (this.$route.params.subRefCode3) {
				return this.subRefChildren3;
			} else if (this.$route.params.subRefId2) {
				return this.subRefChildren2;
			} else if (this.$route.params.subRefId) {
				return this.getSubRefChildren;
			} else {
				if (this.$route.params.referenceName.toUpperCase() == 'CURRENCY') {
					return this.refCurrencies;
				}
				return this.getRefChildren;
			}
		},
		computedFields() {
			return this.refField.filter(item => this.packageCodeVisible ? item : !['packageCode', 'unitCode'].includes(item.key))
		},

	},
	watch: {
		'$route.params.referenceName': {
			async handler() {
				this.packageCodeVisible = ['/references/unit', '/references/warehouse_category/magazin'].includes(window.location.pathname)
				this.removeOrAddChildRefsLink('add');
				this.$store.commit('references/resetRefChildren');
				let parentRef = this.getReferences.find((el) => {
					return el.code.toLowerCase() == this.$route.params.referenceName;
				});
				this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
				await this.getReferenceChildren(this.$route.params.referenceName);
			}
		},
		'$route.params.subRefId': {
			async handler(newVal, oldVal) {
				if (newVal) {
					this.packageCodeVisible = ['/references/unit', '/references/warehouse_category/magazin'].includes(window.location.pathname)
					this.removeOrAddChildRefsLink('add');
					let parentRef = this.getRefChildren.find((el) => {
						return el.code.toLowerCase() == this.$route.params.subRefId;
					});
					this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
					let payload = {
						id: parentRef.id,
						child: 1
					}
					await this.getSubReferenceChildren(payload);
				} else {
					this.parentRefName = this.$route.params.referenceName.charAt(0).toUpperCase() + this.$route.params.referenceName.slice(1).toLowerCase();
				}
			}
		},
		'$route.params.subRefId2': {
			async handler(newVal, oldVal) {
				if (newVal) {
					this.removeOrAddChildRefsLink('add');
					let parentRef = this.getSubRefChildren.find((el) => {
						return el.code.toLowerCase() == this.$route.params.subRefId2;
					});
					this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
					let payload = {
						id: parentRef.id,
						child: 2
					}
					await this.getSubReferenceChildren(payload);
				} else {
					this.parentRefName = this.$route.params.subRefId.charAt(0).toUpperCase() + this.$route.params.subRefId.slice(1).toLowerCase();
				}
			}
		},
		'$route.params.subRefCode3': {
			async handler(newVal, oldVal) {
				if (newVal) {
					this.removeOrAddChildRefsLink('remove');
					let parentRef = this.subRefChildren2.find((el) => {
						return el.code.toLowerCase() == this.$route.params.subRefCode3;
					});
					this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
					let payload = {
						id: parentRef.id,
						child: 3
					}
					await this.getSubReferenceChildren(payload);
				} else {
					this.removeOrAddChildRefsLink('add');
					this.parentRefName = this.$route.params.subRefId2.charAt(0).toUpperCase() + this.$route.params.subRefId2.slice(1).toLowerCase();
				}
			}
		}
	},
	/* CREATED HOOK */
	async created() {
		this.removeOrAddChildRefsLink('add');
		if (this.getReferences.length <= 0) {
			await this.getReferencesList();
		}
		let parentRef = this.getReferences.find((el) => {
			return el.code.toLowerCase() == this.$route.params.referenceName;
		});
		this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
		await this.getReferenceChildren(this.$route.params.referenceName);
		if (this.$route.params.subRefCode3) {
			/** FOR 3RD_SUB_CHILD **/
			this.removeOrAddChildRefsLink('remove');
			if (this.getRefChildren.length <= 0) {
				await this.getReferenceChildren(this.$route.params.referenceName);
			}
			if (this.getSubRefChildren.length <= 0) {
				let parentRef = this.getRefChildren.find((el) => {
					return el.code.toLowerCase() == this.$route.params.subRefId;
				});
				this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
				let payload = {
					id: parentRef.id,
					child: 1
				}
				await this.getSubReferenceChildren(payload);
			}
			if (this.subRefChildren2.length <= 0) {
				let parentRef = this.getSubRefChildren.find((el) => {
					return el.code.toLowerCase() == this.$route.params.subRefId2;
				});
				this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
				let payload = {
					id: parentRef.id,
					child: 2
				}
				await this.getSubReferenceChildren(payload);
			}
			let parentRef = this.subRefChildren2.find((el) => {
				return el.code.toLowerCase() == this.$route.params.subRefCode3;
			});
			this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
			let payload = {
				id: parentRef.id,
				child: 2
			};
			await this.getSubReferenceChildren(payload);
			/** FOR 3RD_SUB_CHILD **/
		} else if (this.$route.params.subRefId2) {
			/** FOR 2ND_SUB_CHILD **/
			this.removeOrAddChildRefsLink('add');
			if (this.getRefChildren.length <= 0) {
				await this.getReferenceChildren(this.$route.params.referenceName);
			}
			if (this.getSubRefChildren.length <= 0) {
				let parentRef = this.getRefChildren.find((el) => {
					return el.code.toLowerCase() == this.$route.params.subRefId;
				});
				this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
				let payload = {
					id: parentRef.id,
					child: 1
				}
				await this.getSubReferenceChildren(payload);
			}
			let parentRef = this.getSubRefChildren.find((el) => {
				return el.code.toLowerCase() == this.$route.params.subRefId2;
			});
			this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
			let payload = {
				id: parentRef.id,
				child: 2
			};
			await this.getSubReferenceChildren(payload);
			/** FOR 2ND_SUB_CHILD **/
		} else if (this.$route.params.subRefId) {
			/** FOR 1ST_SUB_CHILD **/
			this.removeOrAddChildRefsLink('add');
			if (this.getRefChildren.length <= 0) {
				await this.getReferenceChildren(this.$route.params.referenceName);
			}
			let parentRef = this.getRefChildren.find((el) => {
				return el.code.toLowerCase() == this.$route.params.subRefId;
			});
			this.parentRefName = parentRef.name.charAt(0).toUpperCase() + parentRef.name.slice(1).toLowerCase();
			let payload = {
				id: parentRef.id,
				child: 1
			}
			await this.getSubReferenceChildren(payload);
			/** FOR 1ST_SUB_CHILD **/
		}
	},
	/* CREATED HOOK END */

	methods: {
		countDownChanged(dismissCountDown) {
			if (dismissCountDown <= 1) {
				dismissCountDown = 3;
			}
			this.dismissCountDown = dismissCountDown
		},

		/* POPOVER METHODS BEGIN */
		onOpen(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('open')
		},
		onClose(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},
		async onOk(itemId) {
			let idAndRefType = {
				id: itemId,
				type: 'child'
			};
			/** FOR 1ST_SUB_CHILD **/
			if (this.$route.params.subRefId) {
				idAndRefType.type = 'subChild1'
			}
			/** FOR 1ST_SUB_CHILD **/

			/** FOR 2ND_SUB_CHILD **/
			if (this.$route.params.subRefId2) {
				idAndRefType.type = 'subChild2'
			}
			/** FOR 2ND_SUB_CHILD **/

			/** FOR 3RD_SUB_CHILD **/
			if (this.$route.params.subRefCode3) {
				idAndRefType.type = 'subChild3'
			}
			/** FOR 3RD_SUB_CHILD **/

			this.onClose(itemId)
			await this.deleteRef(idAndRefType);
			/** FOR 1ST_SUB_CHILD **/
			if (idAndRefType.type == 'subChild1') {
				let parentRef = this.getRefChildren.find((el) => {
					return el.code.toLowerCase() == this.$route.params.subRefId;
				});
				let payload = {
					id: parentRef.id,
					child: 1
				}
				await this.getSubReferenceChildren(payload);
			}
			/** FOR 1ST_SUB_CHILD **/

			/** FOR 2ND_SUB_CHILD **/
			if (idAndRefType.type == 'subChild2') {
				let parentRef = this.getSubRefChildren.find((el) => {
					return el.code.toLowerCase() == this.$route.params.subRefId2;
				});
				let payload = {
					id: parentRef.id,
					child: 2
				}
				await this.getSubReferenceChildren(payload);
			}
			/** FOR 2ND_SUB_CHILD **/

			/** FOR 3RD_SUB_CHILD **/
			if (idAndRefType.type == 'subChild3') {
				let parentRef = this.subRefChildren2.find((el) => {
					return el.code.toLowerCase() == this.$route.params.subRefCode3;
				});
				let payload = {
					id: parentRef.id,
					child: 3
				}
				await this.getSubReferenceChildren(payload);
			}
			/** FOR 3RD_SUB_CHILD **/
			if (this.notAllowedError) {
				setTimeout(() => {
					this.$store.commit('references/deleteRefError', { message: '', boolean: false })
				}, 4000)
			}
		},
		/* POPOVER METHODS END */

		showRefModal(data) {
			this.refInputNotFilled = false;
			if (data.item) {
				this.tempData = data.item;
				this.modalForAdding = false;
				this.item.id = data.item.id;
				this.item.name = data.item.name;
				this.item.code = data.item.code;
				this.item.mxikCode = data.item.mxikCode;
				this.item.packageCode = data.item.packageCode;
				this.item.unitCode = data.item.unitCode;
				this.item.markingRequired = data.item.markingRequired;
				this.item.value = data.item.value ? data.item.value : '';
				this.item.sort = data.item.sort ? data.item.sort : null;
				this.$refs.updateRefModal.show();
			} else {
				this.item = Object.assign({}, itemInitial);
				this.tempData = Object.assign({}, itemInitial);
				this.modalForAdding = true;
				this.$refs.updateRefModal.show();
			}
		},
		focusMyElement() {
			this.$refs.childRefNameRef.focus();
		},
		closeUpdateRefModal() {
			this.refInputNotFilled = false;
			this.$refs.updateRefModal.hide();
		},
		removeOrAddChildRefsLink(removeOrAdd) {
			if (removeOrAdd == 'remove') {
				/** REMOVE LINK TO CHILD_REFS **/
				let foundIndex = this.refField.findIndex(el => {
					return el.key == 'childRefs'
				});
				if (foundIndex > -1) {
					this.refField.splice(foundIndex, 1);
				}
				/** -------------- **/
			} else if (removeOrAdd == 'add') {
				/** ADD LINK TO CHILD_REFS **/
				let foundIndex = this.refField.findIndex(el => {
					return el.key == 'childRefs'
				});
				if (foundIndex == -1) {
					this.refField.splice(this.refField.length - 1, 0, {
						key: 'childRefs',
						label: this.$t('reference.child')
					});
				}
				/** -------------- **/
			}
		},
		async saveRef() {
			if (this.item.name.trim() != '' && this.item.code.trim() != '') {
				// if (this.item.name.trim() != this.tempData.name.trim() || this.item.code.trim() != this.tempData.code.trim() ||
				//     (this.item.value ? this.item.value.trim() : this.item.value) != (this.tempData.value ? this.tempData.value.trim() : this.tempData.value) ||
				//     (this.item.sort ? this.item.sort.toString().trim() : this.item.sort) != (this.tempData.sort ? this.tempData.sort.toString().trim() : this.tempData.sort)) {
				let parentRef = this.getReferences.find((el) => {
					return el.code.toUpperCase() === this.$route.params.referenceName.toUpperCase()
				});
				/** FOR 1ST_SUB_CHILD **/
				if (this.$route.params.subRefId) {
					parentRef = this.getRefChildren.find((el) => {
						return el.code.toLowerCase() == this.$route.params.subRefId;
					});
				}
				/** FOR 1ST_SUB_CHILD **/

				/** FOR 2ND_SUB_CHILD **/
				if (this.$route.params.subRefId2) {
					parentRef = this.getSubRefChildren.find((el) => {
						return el.code.toLowerCase() == this.$route.params.subRefId2;
					});
				}
				/** FOR 2ND_SUB_CHILD **/

				/** FOR 3ND_SUB_CHILD **/
				if (this.$route.params.subRefCode3) {
					parentRef = this.subRefChildren2.find((el) => {
						return el.code.toLowerCase() == this.$route.params.subRefCode3;
					});
				}
				/** FOR 3ND_SUB_CHILD **/
				this.item.parentId = parentRef.id;
				this.item.parentName = parentRef.name;
				this.refInputNotFilled = false;
				await this.updateOrCreateRefChild(this.item);
				if (this.addRefError) {
					await setTimeout(() => {
						this.$store.commit('references/addRefError', { message: '', boolean: false })
					}, 4000)
				} else {
					/** FOR 1ST_2ND_3RD_SUB_CHILD **/
					if (this.$route.params.subRefId || this.$route.params.subRefId2 || this.$route.params.subRefCode3) {
						let payload = {
							id: parentRef.id,
							child: 1
						};
						if (this.$route.params.subRefCode3) {
							payload.child = 3;
						} else if (this.$route.params.subRefId2) {
							payload.child = 2;
						}
						await this.getSubReferenceChildren(payload);
					}
					/** FOR 1ST_2ND_3RD_SUB_CHILD **/
					else {
						await this.getReferenceChildren(parentRef.code);
					}
					this.item = Object.assign({}, itemInitial);
					this.$refs.updateRefModal.hide();
				}
				// }
				//  else {
				// this.refInputNotFilled = false;
				// this.$refs.updateRefModal.hide();
				// }
			} else {
				this.refInputNotFilled = true;
			}
		},
		async childRefsLink(refCode) {
			let parentRefCode = refCode.toLowerCase();
			if (this.$route.params.subRefId2) {
				this.$router.push({ name: 'Reference:subRefCode3', params: { subRefCode3: parentRefCode } })
			} else if (this.$route.params.subRefId) {
				this.$router.push({ name: 'Reference:subRefId2', params: { subRefId2: parentRefCode } })
			} else {
				this.$router.push({ name: 'Reference:subRefId', params: { subRefId: parentRefCode } })
			}
		},
		...mapActions('references', [
			'getReferencesList', 'getReferenceChildren', 'deleteRef', 'updateOrCreateRefChild', 'getSubReferenceChildren'
		]),

	}
}
</script>

<style scoped></style>
